//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'login',
  data () {
    return {
      account: '',
      password: '',
      checkLogin:false,
    }
  },
  created(){
    if(!this.$func.getLocal('token')){
      this.getCode();
    }else{
      // this.checkCid();
      this.checkCid();
    }
  },
  methods:{
     getCode(){
      var local = window.location.href
      this.code = this.getUrlCode().code 
      var appid = 'wx293713f8b5be3b5b' 
      if (this.code == null || this.code === '') {
        window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${encodeURIComponent(local)}&response_type=code&scope=snsapi_userinfo#wechat_redirect`;
      } else {
        this.login();
      }
    },
    getUrlCode() {
      var url = window.location.href
      var theRequest = new Object()
      if (url.indexOf("?") != -1) {
         var urls = url.split("?")
          var strs = urls[1].split("&")
          for(var i = 0; i < strs.length; i++) {
              theRequest[strs[i].split("=")[0]]=(strs[i].split("=")[1])
          }
      }
      return theRequest
    },
    login(){
        this.$api.login({code:this.code}).then((res)=>{
          if(res){
            if(res.data.token){
              this.$func.setLocal('token',res.data.token);
              if(res.data.cid > 0){
                window.location.href = "/#/user";
              }else{
                this.checkLogin = true;
              }
            }
          }
        })  
    },
    checkCid(){
      this.$api.checkCid({}).then((res)=>{
        if(res.code == 2){
          this.checkLogin = true;
          // this.$func.showToast(res.msg);
          return false;
        }else{
          window.location.href = "/#/user";
        }
      })
    },
    submit(){
        let that = this;
        if (!that.account) {
            that.$func.showToast('请输入账号');
            return false;
        }
        if (!that.password) {
            that.$func.showToast('请输入密码');
            return false;
        }
        that.$api.loginStation({
            account: that.account,
            password: that.password,
        }).then((res)=>{
          if(res){
             window.location.href = "/#/user";
          }
        });
    },
    out(){
      // this.$func.confirm('确认退出账号？','温馨提示',()=>{
        this.$api.out({}).then((res)=>{
          this.$func.setLocal('node_v1','');
          this.$func.setLocal('grade','');
          this.$router.push({path:'/login'})
        })
      // })
    },
  }
}



// WEBPACK FOOTER //
// ./src/pages/login.vue